"use client";

import { useEffect } from "react";

import { loadWhenIdle } from "@medceptor/meta-pixel/idle";

import { isMetaPixelPageUrl } from "@/lib/analytics/meta-pixel-pages";

/** Meta PageViews, one per page mount (the pixel's own history listener is
 *  off). Re-checks the allowlist against the URL the browser shows, and loads
 *  in the idle callback so it never competes with hydration. */
export function MetaPixel({ pixelId }: { pixelId: string }) {
  useEffect(() => {
    if (!isMetaPixelPageUrl(window.location.href)) return;
    return loadWhenIdle(
      () => import("@/lib/analytics/meta-pixel-client"),
      ({ trackMetaPageView }) => trackMetaPageView(pixelId),
    );
  }, [pixelId]);
  return null;
}
